import { RPCProcedure } from '@bits/rpc';
import useSWR from 'swr';

import { rpcClient } from '@/lib/api/rpc-client';

export const useAuditTrail = (
  resourceId: string,
  options: RPCProcedure<'/audit.list'>
) =>
  useSWR(['audit-trail', resourceId, options], () =>
    fetchAuditTrail(resourceId, options)
  );

export const fetchAuditTrail = (
  /**
   * Resource ID can represent any resource that has an audit trail.
   * For example, a case, an entity, an application, etc.
   */
  resourceId: string,
  options: RPCProcedure<'/audit.list'>
) =>
  rpcClient.call('/audit.list', {
    ...options,
    filters: [
      ...(options.filters || []),
      {
        field: 'resourceId',
        origin: 'SYSTEM',
        type: 'VALUE',
        values: [resourceId],
      },
    ],
  });
